import { render, staticRenderFns } from "./loadBlock.vue?vue&type=template&id=74d24c70"
import script from "./loadBlock.vue?vue&type=script&lang=js"
export * from "./loadBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports